import { render, staticRenderFns } from "./xscxlistyc.vue?vue&type=template&id=8ef6f77c"
import script from "./xscxlistyc.vue?vue&type=script&lang=js"
export * from "./xscxlistyc.vue?vue&type=script&lang=js"
import style0 from "./xscxlistyc.vue?vue&type=style&index=0&id=8ef6f77c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports